<item-preview-wrapper
    [config]="config"
    [isItem]="true"
></item-preview-wrapper>
